import { get, put } from './config';

export const load = (eventId) =>
  get(`/events/${eventId}/invitation_template`).then((payload) => payload);

export const save = (invitation_template, eventId) =>
  put(`/events/${eventId}/invitation_template`, {
    invitation_template,
  });
